import { render, staticRenderFns } from "./CompraPacoteFretePadrao.vue?vue&type=template&id=912d8512&scoped=true&"
import script from "./CompraPacoteFretePadrao.vue?vue&type=script&lang=js&"
export * from "./CompraPacoteFretePadrao.vue?vue&type=script&lang=js&"
import style0 from "./CompraPacoteFretePadrao.vue?vue&type=style&index=0&id=912d8512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912d8512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemAction,VListItemAvatar,VListItemContent})
